export default __webpack_public_path__ + "static/media/banner2.5b101530.jpg";